// src/eventBus.js
import Vue from 'vue'; // 导入 Vue
export const EventBus = new Vue(); // 创建一个新的 Vue 实例作为事件总线
